import React, { useCallback } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

const AppliedFilter = ({ filterType, filterName, value, onClose }) => {
  let appliedFilterValue = value
  if (filterType !== 'string_filters') {
    appliedFilterValue = filterName
  } else if (filterType === 'string_filters') {
    if (value === 'false' && filterName === 'Available') {
      appliedFilterValue = 'Not ' + filterName
    } else if (value === 'false' && filterName === 'For Sale') {
      appliedFilterValue = "Doesn't Have Sale Listings"
    } else if (value === 'false') {
      appliedFilterValue = 'Not ' + filterName
    } else if (value === 'true') {
      appliedFilterValue = filterName
    } else if (value === 'Yes' && filterName === 'For Sale') {
      appliedFilterValue = 'For Sale'
    } else if (value === 'Yes' && filterName === 'For Rent') {
      appliedFilterValue = 'For Rent'
    }
  }
  return (
    <>
      <span
        className='filter-name'
        data-filtertype={filterType}
        data-filtername={filterName}
        data-filtervalue={value}
      >{appliedFilterValue}
      </span>
      <button
        className='remove-filter'
        data-filtertype={filterType}
        data-filtername={filterName}
        data-filtervalue={value}
        onClick={onClose}
      > X
      </button>
    </>
  )
}
AppliedFilter.propTypes = {
  filterType: PropTypes.string.isRequired,
  filterName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
}

const getSelectedMinMaxFilters = (currentSelectedFilters) => {
  const aggMinMax = {}
  if (currentSelectedFilters.number_range_filters) {
    currentSelectedFilters.number_range_filters.forEach((filter, _) => {
      if (filter.name.includes('(min)') || filter.name.includes('(max)')) {
        // get the name without (min)/(max)
        const name = filter.name.replace(' (min)', '').replace(' (max)', '')
        // create the new filter.name if it doesn't exist
        let gteValue = filter.gte
        if (!aggMinMax[name]) {
          aggMinMax[name] = { name: name, values: [] }
        }
        if (!gteValue) {
          gteValue = filter.lte
        }
        // populate the values with min or max
        aggMinMax[name].values.push(gteValue)
      } else {
        // create the new filter.name if it doesn't exist
        const lteValue = filter.lte
        if (!aggMinMax[filter.name]) {
          aggMinMax[filter.name] = { name: filter.name, values: [] }
        }
        // populate the values with max
        aggMinMax[filter.name].values.push(lteValue)
      }
    })
  }
  return aggMinMax
}

const AppliedFilters = ({ selectedFilters, handleFilterSelection, deselectFilter, deselectMinMaxFilter, deselectAtLeastFilter }) => {
  const currentSelectedFilters = JSON.parse(selectedFilters)

  const onClose = useCallback((event) => {
    const filterType = event.target.dataset.filtertype
    let filterValue = event.target.dataset.filtervalue
    if (filterType === 'number_filters') {
      filterValue = parseFloat(filterValue)
    }
    const newSelectedFilters = deselectFilter(selectedFilters, filterType, event.target.dataset.filtername, filterValue)
    handleFilterSelection(newSelectedFilters)
  }, [deselectFilter])

  const onMinMaxFilterClose = useCallback((event) => {
    const newSelectedFilters = deselectMinMaxFilter(selectedFilters, event.target.dataset.filtername)
    handleFilterSelection(newSelectedFilters)
  }, [deselectMinMaxFilter])

  const onAtLeastFilterClose = useCallback((event) => {
    const newSelectedFilters = deselectAtLeastFilter(selectedFilters, event.target.dataset.filtername)
    handleFilterSelection(newSelectedFilters)
  }, [deselectAtLeastFilter])

  const children = useCallback(() => {
    const appliedFilters = []
    if (currentSelectedFilters.string_filters) {
      currentSelectedFilters.string_filters.forEach((filter, _) => {
        filter.values.forEach((value, index) => {
          appliedFilters.push(<AppliedFilter
            key={`${filter.name}-index-${index}`}
            filterType='string_filters'
            filterName={filter.name}
            value={value}
            onClose={onClose} />)
          return appliedFilters
        })
      })
    }
    if (currentSelectedFilters.number_filters) {
      currentSelectedFilters.number_filters.forEach((filter, _) => {
        filter.values.forEach((value, index) => {
          appliedFilters.push(<AppliedFilter
            key={`${filter.name}-index-${index}`}
            filterType='number_filters'
            filterName={filter.name}
            value={value}
            onClose={onClose} />)
          return appliedFilters
        })
      })
    }
    const aggMinMax = getSelectedMinMaxFilters(currentSelectedFilters)

    Object.values(aggMinMax).forEach((filter, index) => {
      if (filter.name === 'Max Aperture') {
        appliedFilters.push(
          <AppliedFilter
            key={`${filter.name}-index-${index}`}
            filterType='number_range_filters'
            filterName={filter.name}
            value={filter.values}
            onClose={onAtLeastFilterClose}
          />)
      } else {
        appliedFilters.push(
          <AppliedFilter
            key={`${filter.name}-index-${index}`}
            filterType='number_range_filters'
            filterName={filter.name}
            value={filter.values}
            onClose={onMinMaxFilterClose}
          />)
      }
      return appliedFilters
    })
    return appliedFilters
  }, [selectedFilters])

  // This component needs to be refactored when whole page is moved to react.
  // Then we could just position the component directly, without the need for `createPortal`.
  return ReactDOM.createPortal(
    children(),
    (document.getElementById('applied-filters') || document.createElement('div'))
  )
}

AppliedFilters.propTypes = {
  selectedFilters: PropTypes.string.isRequired,
  handleFilterSelection: PropTypes.func.isRequired,
  deselectFilter: PropTypes.func.isRequired,
  deselectMinMaxFilter: PropTypes.func.isRequired,
  deselectAtLeastFilter: PropTypes.func.isRequired
}
export { AppliedFilters, AppliedFilter }
export default AppliedFilters
